
import React, { ReactElement, useCallback, useContext, useEffect, useRef, useState } from "react";
import { Hooks,Util,Context, Platform, Bridge } from "@xt/xtbase";
import SvgIcon from "@xt/SvgIcon";
const {XtContext} = Context;
const {useTranslation} = Hooks;
const { getUrl } = Util;
import { Modal, Button, Select, Upload, message } from "antd";
import cs from "./index.module.less";
import { VipInfoObj, FuVipInfoObj } from "../common";
import { getOtherPlatforms, postRateUpload, postUserStepApply, getUserStepApplyResult } from "@/api/v4/futures";
import { UploadFile } from 'antd/lib/upload/interface';
import rateIcon02 from "@/assets/images/rate/02.png";
const vInfoObj = new VipInfoObj(null);
const fuvInfoObj = new FuVipInfoObj(null);

import type { UploadProps } from 'antd';

interface PropsType {
    vipInfo?: typeof vInfoObj,
    fuVipInfo?: typeof fuvInfoObj,
    fuVipList?: typeof fuvInfoObj[],
    rateType: number
}
interface UploadResult {
    miniUrl: string;
    url: string;
}
const VipLevel: React.FC<PropsType> = ({vipInfo, fuVipInfo, fuVipList, rateType}): ReactElement => {
    const t = useTranslation();
    const [ appState ] = useContext<any>(XtContext)
    const {loginStatus} = appState;
    const isLogin = loginStatus === 1;
    const [applyState, setApplyState]  = useState(-1);
    const isInApp = Platform.isInApp();
    const headerOptions = {headers:{device: isInApp ? "app" : "web"}};
    
    const onLogin = () => {
        if (isInApp) {
            Bridge.routeTo("/account/login");
            return;
        }
        location.href = getUrl("/accounts/login?backurl="+encodeURIComponent(location.href));
    };

    const [isModalOpen, setIsModalOpen]  = useState(false);
    const onUpgradeVip = () => {
        if (fuVipInfo?.specialType || applyState === 0 || applyState === 1) return;
        setIsModalOpen(true);
    };

    const [thirdPlatformList, setThirdPlatformList] = useState<string[]>([]);
    useEffect(() => {
        if (!+rateType || loginStatus != 1) return;
        // getUserStepApplyResult(headerOptions).then(res => {
        //     const { state=0 } = res;
        //     setApplyState(state);
        // });
    }, [rateType,loginStatus]);

    useEffect(() => {
        if(!isModalOpen) return;
        getOtherPlatforms(headerOptions).then(res => {
            setThirdPlatformList(res);
        });
    }, [isModalOpen]);

    const [thirdPlatForm, setThirdPlatForm] = useState<string[]>([]);
    const onTriPartyChange = (val: string[]) => {
        setThirdPlatForm(val);
    };

    const [applyLevel, setApplyLevel] = useState('');
    const onApplyLevelChange = (val: string) => {
        setApplyLevel(val);
    };

    const [fileList, setFileList] = useState<UploadFile<UploadResult>[]>([]);
    const [preview, setPreview] = useState({
        visible: false,
        title: '',
        url: '',
    });
    
    const onPreview = async (file: UploadFile) => {
        setPreview({
          visible: true,
          title: file.name,
          url: file.url as string,
        });
    };

    const beforeUpload = (file: any) => {
        const { size, type } = file;
        
        if (size > 2 * 1024 * 1024) {
          // 限制上传图片每张不超过2M
          message.error(t('rate.beforeUploadTips'));
          return false;
        }

        if (!["image/png","image/jpg","image/jpeg","image/svg"].includes(type)) {
            message.error(t("imageFormatTip"));
        }
    
        return true;
    };

    const customRequest = async (options: any) => {

        const { file, onSuccess, onError } = options;
        const data = new FormData();
        data.append('file', file);
        
        postRateUpload(data, { headers:{ "Content-Type": "multipart/form-data", device: isInApp ? "app" : "web" }}).then(res => {
            
            const URL = window.URL || window.webkitURL;
            const imgUrl = URL.createObjectURL(file);
            setFileList([
              ...fileList,
              {
                uid: file.uid,
                name: file.name,
                url: imgUrl,
                status: 'done',
                response: res,
              },
            ]);
            onSuccess(res, file);
          })
          .catch(err => {
            onError(err);
          });
    };

    const onUploadChange = (options: any) => {
        const { uid, status } = options.file;
        if (status === 'removed') {
          setFileList(fileList.filter(item => item.uid !== uid));
        }
    };

    const handleCancel = () => {
        setFileList([]);
        setIsModalOpen(false);
    };

    const canApply = thirdPlatForm.length && applyLevel && fileList.length;
    const handleSubmit = () => {

        if (!canApply) return;
        postUserStepApply({
            applyStepRateId: applyLevel,
            miniImageUrl: fileList.map(({ response }) => response?.miniUrl),
            sourceUrl: fileList.map(({ response }) => response?.url),
            source: thirdPlatForm.join(','),
        },
        {
            headers: {
                'Content-Type': 'application/json',
                device: isInApp ? "app" : "web"
            }
        }).finally(() => {
            // fetchUserApplyResult(); // 申请用户结果
            fileList.forEach(({ url }) => url && URL.revokeObjectURL(url)); // 释放URL对象
            setIsModalOpen(false);

            // getUserStepApplyResult(headerOptions).then(res => {
            //     const { state=0 } = res;
            //     setApplyState(state);
            // });
        });
    };

    const uploadProps: UploadProps = {
        name: 'file',
        action: "IMG UPLOAD",
        onPreview: onPreview,
        beforeUpload: beforeUpload,
        customRequest: customRequest,
        onChange: onUploadChange,
        accept: !isInApp ? ".jpg,.jpeg,.png,.svg" : undefined,
        listType: "picture-card",
        fileList: fileList
    };

    const windowYRef = useRef(0);
    const disabledScroll = useCallback(() => {
        window.scrollTo(0, windowYRef.current);
    }, []);

    useEffect(() => {
        if (isModalOpen) {
            windowYRef.current = window.scrollY;
            document.addEventListener('scroll', disabledScroll);
        } else {
            document.removeEventListener('scroll', disabledScroll);
        }
    }, [isModalOpen]);

    const makerVal = +rateType === 0 ? vipInfo?.makerFeeRate : fuVipInfo?.makerFeeStr;
    const takerVal = +rateType === 0 ? vipInfo?.takerFeeRate : fuVipInfo?.takerFeeStr;
    const rateDisplay = (v: any) => (v != null && v !== "" ? `${v}${isLogin ? "%" : ""}` : "--");

    return (
        <>
            <div className={cs.main}>
                <div className={cs.titleRow}>
                    <img src={rateIcon02} alt="" className={cs.titleIcon} width={16} height={16} />
                    <div className={cs.title}>
                        {+rateType === 1 ? (
                            <>
                                <span>{t("rate.contractTradingRate")}</span>
                                {isLogin && !fuVipInfo?.specialType && fuVipInfo?.discountLevel > 0 && <div className={cs.retainDays}>{t("retainDays")} {fuVipInfo?.levelReturnDay ?? "-"}</div>}
                            </>
                        ) : (
                            <>
                                <div dangerouslySetInnerHTML={{ __html: t("rate.vipLevelTip", [vipInfo?.curLevelName || ""]) }} />
                                {!isLogin && <span className={cs.login} onClick={onLogin} style={{ cursor: "pointer" }}>{t("home.login")}</span>}
                            </>
                        )}
                    </div>
                </div>

                <div className={`${cs.rateCard} ${+rateType === 1 ? cs.contractSubTitle : ""}`}>
                    <div className={cs.rateCol}>
                        <p className={cs.rateLabel}>Maker</p>
                        <p className={cs.rateValue}>0.02%</p>
                    </div>
                    <div className={cs.rateCol}>
                        <p className={cs.rateLabel}>Taker</p>
                        <p className={cs.rateValue}>0.02%</p>
                    </div>
                </div>
{/*                 
                { isLogin && +rateType === 1 && 
                    <div className={cs.upgradeView}>
                        {t("rate.upgradeTip")} <span className={(fuVipInfo?.specialType || applyState === 0 || applyState === 1) ? cs.disableUpgrade : ""} onClick={onUpgradeVip}>{t("rate.applyUpgrade")}</span>
                        { applyState === 0 && <div className={`${cs.applyState} ${cs.applying}`}>{ t("applying") }</div> }
                        { applyState === 1 && <div className={`${cs.applyState} ${cs.applied}`}>{ t("applied") }</div> }
                    </div>
                } */}

                {/* <div className={cs.titleBg} style={{"backgroundImage":`url(${TitleBg})`}}></div> */}

                <Modal
                    title={t("rate.applyVip")}
                    wrapClassName="applyVipModal"
                    visible={isModalOpen} 
                    onCancel={handleCancel}
                    destroyOnClose={true}
                    closeIcon={<SvgIcon icon="close-round" style={undefined}></SvgIcon>}
                    footer={[
                        <Button className={cs.modalFootBtn} key="submit" type="primary" onClick={handleSubmit}>
                            {t("apply")}
                        </Button>,
                    ]}>
                    <div className={cs.modalForm}>
                        <Select
                            size="large"
                            mode="multiple"
                            showArrow
                            onChange={onTriPartyChange}
                            placeholder={t('rate.thirdPlatform')}
                            dropdownStyle={{
                                zIndex: 100005,
                            }}
                            style={{ width: '100%', marginBottom: '16px' }}
                            >
                            {thirdPlatformList.map(item => (
                                <Select.Option value={item} key={item}> {item}</Select.Option>
                            ))}
                        </Select>
                        <Select
                            size="large"
                            onChange={onApplyLevelChange}
                            placeholder={t('rate.applyLevel')}
                            dropdownStyle={{
                                zIndex: 100005,
                            }}
                            style={{ width: '100%', marginBottom: '16px' }}
                            >
                            {
                                fuVipList && fuVipList
                                    .filter((_, idx) => !!idx) // 移除VIP0
                                    .map(({ id, stepName }) => (
                                        <Select.Option value={id} key={id}>
                                            {stepName}
                                        </Select.Option>
                                    ))
                            }
                        </Select>
                        <div className={cs.uploadTips}>{t("rate.uploadTips")}</div>
                        <Upload {...uploadProps}>
                            {fileList.length >= 5 ? null : (
                                <div className={cs.uploadBtn}>
                                    <div> + </div>
                                </div>
                            )}
                        </Upload>
                        {/* <Upload
                            action="IMG UPLOAD"
                            onPreview={onPreview}
                            beforeUpload={beforeUpload}
                            customRequest={customRequest} 
                            onChange={onUploadChange}
                            accept=".jpg,.jpeg,.png,.svg"
                            listType="picture-card"
                            fileList={fileList}
                            >
                            {fileList.length >= 5 ? null : (
                                <div className={cs.uploadBtn}>
                                    <div> + </div>
                                </div>
                            )}
                        </Upload> */}
                        <div className={cs.uploadFormat}>{t("rate.uploadTip")}</div>
                    </div>

                    <Modal
                        visible={preview.visible}
                        footer={null}
                        title={preview.title}
                        destroyOnClose
                        bodyStyle={{ height: 423 }}
                        className={cs.upload}
                        closeIcon={<SvgIcon icon="close-round" style={undefined}></SvgIcon>}
                        onCancel={() => setPreview({} as any)}
                    >
                        <img className={cs.previewImg} src={preview.url} alt="" />
                    </Modal>
                </Modal>
            </div>
            
        </>)
}
export default VipLevel;